/**
 * Ikonkalar — inline SVG, tashqi kutubxonasiz.
 *
 * NEGA PAKET EMAS: Mini App Telegram ichida, ko'pincha sekin mobil
 * internetda ochiladi. Bizga ~18 ta ikonka kerak, @phosphor-icons/react
 * esa butun to'plamni olib keladi. Inline SVG — nol bog'liqlik, nol
 * tree-shaking xavfi.
 *
 * NEGA EMOJI EMAS: emoji shriftga bog'liq (Android/iOS/Windows da har xil
 * ko'rinadi), rangini boshqarib bo'lmaydi va dizayn tokenlariga
 * bo'ysunmaydi. Bayroqlar (🇬🇧) bundan mustasno — ular MA'LUMOT, ikonka
 * emas, va ularning ma'nosi aynan emoji ko'rinishida.
 *
 * Barchasi bir uslubda: 24x24 viewBox, faqat chiziq (stroke), qalinlik
 * 1.75, yumaloq uchlar. `currentColor` — rang matn rangidan meros oladi.
 */

import type { SVGProps } from "react";

type IconProps = {
  size?: number;
  className?: string;
} & Omit<SVGProps<SVGSVGElement>, "width" | "height">;

function Icon({ size = 22, className, children, ...rest }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      // Ikonka bezak: ekran o'quvchi uni o'qimaydi. Ma'no yonidagi
      // matnda yoki tugmaning aria-label'ida bo'ladi.
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

/* ------------------------------------------------------------ navigatsiya */

export const IconSearch = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M16.5 16.5 21 21" />
  </Icon>
);

export const IconHome = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 10.7 12 3.4l9 7.3" />
    <path d="M5.6 9.6V20h12.8V9.6" />
    <path d="M9.8 20v-5.4h4.4V20" />
  </Icon>
);

export const IconBookmark = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6.5 3.6h11v16.8L12 16.2l-5.5 4.2z" />
  </Icon>
);

export const IconBookmarkFilled = (p: IconProps) => (
  <Icon {...p} fill="currentColor">
    <path d="M6.5 3.6h11v16.8L12 16.2l-5.5 4.2z" />
  </Icon>
);

/* Yurak — xatcho'p (saqlash) dan BOSHQA ma'no.
 *
 * Ikkita ikonka ataylab shakl jihatidan farq qiladi: xatcho'p burchakli
 * va tik, yurak yumaloq. Foydalanuvchi ikkalasini yonma-yon ko'radi va
 * bir qarashda ajratishi kerak — faqat rang bilan farqlash yetarli
 * emas (rang ko'rmaydigan odam uchun ular bir xil bo'lib qolardi). */
export const IconHeart = (p: IconProps) => (
  <Icon {...p}>
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </Icon>
);

export const IconHeartFilled = (p: IconProps) => (
  <Icon {...p} fill="currentColor">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
  </Icon>
);

export const IconChevronDown = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6 9.5 12 15.5 18 9.5" />
  </Icon>
);

export const IconChevronRight = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9.5 6 15.5 12 9.5 18" />
  </Icon>
);

export const IconCheck = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4.4 12.4 9.6 17.6 19.6 6.6" />
  </Icon>
);

export const IconClose = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6 6 18 18M18 6 6 18" />
  </Icon>
);

/* ---------------------------------------------------------------- bo'limlar */

export const IconBolt = (p: IconProps) => (
  <Icon {...p}>
    <path d="M13.4 2.5 5.2 13.4h5.6l-.8 8.1 8.8-11.2h-5.8z" />
  </Icon>
);

export const IconSparkle = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 2.6l2.5 6.1 6.1.5-4.7 4.1 1.4 6-5.3-3.2-5.3 3.2 1.4-6-4.7-4.1 6.1-.5z" />
  </Icon>
);

/** Karnay — lentadagi reklama slaydi uchun (TZ §10.8). */
export const IconMegaphone = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 9.4h3.4L18 4.6v14.8L7.4 14.6H4z" />
    <path d="M4 9.4a2.4 2.4 0 0 0 0 5.2" />
    <path d="M20.4 9.8a3.4 3.4 0 0 1 0 4.4" />
    <path d="M8.6 15v3.2a2 2 0 0 0 3.8.8" />
  </Icon>
);

export const IconGrid = (p: IconProps) => (
  <Icon {...p}>
    <rect x="3.4" y="3.4" width="7.2" height="7.2" rx="2" />
    <rect x="13.4" y="3.4" width="7.2" height="7.2" rx="2" />
    <rect x="3.4" y="13.4" width="7.2" height="7.2" rx="2" />
    <rect x="13.4" y="13.4" width="7.2" height="7.2" rx="2" />
  </Icon>
);

export const IconClock = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="8.8" />
    <path d="M12 6.6V12l3.6 2.1" />
  </Icon>
);

export const IconFilter = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3.5 5.5h17M6.5 12h11M10 18.5h4" />
  </Icon>
);

/* ------------------------------------------------------------------ holat */

export const IconAlert = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 3.6 21.6 20.4H2.4z" />
    <path d="M12 9.8v4.2" />
    <path d="M12 17.2h.01" />
  </Icon>
);

export const IconCompass = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="8.8" />
    <path d="M15.6 8.4 13.8 13.8 8.4 15.6l1.8-5.4z" />
  </Icon>
);

export const IconSprout = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 21v-8.4" />
    <path d="M12 12.6C12 9.3 9.4 6.7 6 6.7c0 3.3 2.7 5.9 6 5.9z" />
    <path d="M12 12.6c0-3.3 2.6-5.9 6-5.9 0 3.3-2.7 5.9-6 5.9z" />
  </Icon>
);

export const IconLink = (p: IconProps) => (
  <Icon {...p}>
    <path d="M10.3 13.7a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.3 1.3" />
    <path d="M13.7 10.3a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.3-1.3" />
  </Icon>
);

/**
 * Xarita ko'rinishi — tashqi so'rovsiz o'rinbosar.
 *
 * Bu haqiqiy joy emas, umumiy chizma: ko'chalar, kvartallar va markazda
 * nuqta. Foydalanuvchi bosgunga qadar hech qayerga so'rov ketmaydi,
 * lekin bu yerda xarita borligi darrov ko'rinadi.
 *
 * `Icon` yordamchisidan foydalanmaydi — u 24×24 va faqat chiziqli,
 * bu yerda esa to'ldirilgan yuzalar va boshqa nisbat kerak.
 */
export const MapPreview = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 320 140"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <rect width="320" height="140" fill="#0d2244" />
    {/* kvartallar */}
    <g fill="#14315e">
      <rect x="12" y="14" width="70" height="38" rx="3" />
      <rect x="12" y="66" width="70" height="26" rx="3" />
      <rect x="12" y="104" width="46" height="24" rx="3" />
      <rect x="104" y="14" width="54" height="30" rx="3" />
      <rect x="104" y="96" width="54" height="32" rx="3" />
      <rect x="182" y="14" width="60" height="44" rx="3" />
      <rect x="182" y="74" width="38" height="24" rx="3" />
      <rect x="182" y="110" width="60" height="18" rx="3" />
      <rect x="262" y="30" width="46" height="52" rx="3" />
      <rect x="262" y="96" width="46" height="30" rx="3" />
    </g>
    {/* ko'chalar */}
    <g stroke="#1b3d72" strokeWidth="6" strokeLinecap="round">
      <path d="M94 0v140M170 0v140M252 0v140" />
      <path d="M0 60h320M0 88h320" />
    </g>
    {/* daryo */}
    <path
      d="M0 118c40-6 62 10 96 4s54-26 92-20 62 22 132 14"
      stroke="#1d4f8a"
      strokeWidth="9"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

/** Xarita nuqtasi — joylashuv bo'limi uchun. */
export const IconMapPin = (p: IconProps) => (
  <Icon {...p}>
    <path d="M19 10.4c0 5.2-7 11-7 11s-7-5.8-7-11a7 7 0 0 1 14 0z" />
    <circle cx="12" cy="10.2" r="2.6" />
  </Icon>
);

/** Hujjatlar to'plami — kerakli hujjatlar bo'limi uchun. */
export const IconFiles = (p: IconProps) => (
  <Icon {...p}>
    <path d="M8.4 3.4h5.8l4.4 4.4v10.4a1.8 1.8 0 0 1-1.8 1.8H8.4a1.8 1.8 0 0 1-1.8-1.8V5.2a1.8 1.8 0 0 1 1.8-1.8z" />
    <path d="M14.2 3.4v4.4h4.4" />
    <path d="M9.8 12.6h5.6" />
    <path d="M9.8 16h4" />
  </Icon>
);

/** Tashqi havola — yangi oynada ochilishini bildiradi. */
export const IconExternal = (p: IconProps) => (
  <Icon {...p}>
    <path d="M13.6 4.4h6v6" />
    <path d="M19.6 4.4 11 13" />
    <path d="M18.4 14.2v4.6a1.8 1.8 0 0 1-1.8 1.8H5.2a1.8 1.8 0 0 1-1.8-1.8V7.4a1.8 1.8 0 0 1 1.8-1.8h4.6" />
  </Icon>
);

export const IconShare = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 12v7.2a1.4 1.4 0 0 0 1.4 1.4h13.2a1.4 1.4 0 0 0 1.4-1.4V12" />
    <path d="M12 15.4V3.4" />
    <path d="M7.8 7.6 12 3.4l4.2 4.2" />
  </Icon>
);

export const IconBell = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6.2 10.2a5.8 5.8 0 0 1 11.6 0c0 4.2 1.4 5.8 1.4 5.8H4.8s1.4-1.6 1.4-5.8z" />
    <path d="M10.2 19.2a2 2 0 0 0 3.6 0" />
  </Icon>
);

export const IconBellOff = (p: IconProps) => (
  <Icon {...p}>
    <path d="M6.2 10.2a5.8 5.8 0 0 1 8.2-5.3" />
    <path d="M17.8 12.4c0 3.6 1.4 3.6 1.4 3.6H8" />
    <path d="M10.2 19.2a2 2 0 0 0 3.6 0" />
    <path d="M3.6 3.6 20.4 20.4" />
  </Icon>
);

export const IconText = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4.6 6.4h14.8" />
    <path d="M4.6 11.2h14.8" />
    <path d="M4.6 16h9.4" />
  </Icon>
);

export const IconUsers = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="9.4" cy="8" r="3.6" />
    <path d="M3.2 20.2a6.2 6.2 0 0 1 12.4 0" />
    <path d="M16.4 4.8a3.6 3.6 0 0 1 0 6.9" />
    <path d="M18 14.6a6.2 6.2 0 0 1 2.8 5.6" />
  </Icon>
);

/* ------------------------------------------------------------ imkoniyat turlari */

const IconCap = (p: IconProps) => (
  <Icon {...p}>
    <path d="M2.6 8.6 12 4.2l9.4 4.4L12 13z" />
    <path d="M6.6 10.7V16c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-5.3" />
  </Icon>
);

const IconExchange = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 8.6h13.4" />
    <path d="M14.2 5.4 17.4 8.6 14.2 11.8" />
    <path d="M20 15.4H6.6" />
    <path d="M9.8 12.2 6.6 15.4 9.8 18.6" />
  </Icon>
);

const IconFlask = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9.6 3.2v6.2l-5 9.1a1.6 1.6 0 0 0 1.4 2.3h12a1.6 1.6 0 0 0 1.4-2.3l-5-9.1V3.2" />
    <path d="M8.4 3.2h7.2" />
    <path d="M7.2 15.2h9.6" />
  </Icon>
);

const IconBriefcase = (p: IconProps) => (
  <Icon {...p}>
    <rect x="2.8" y="7.2" width="18.4" height="13" rx="2.2" />
    <path d="M8.8 7.2V5.4a1.8 1.8 0 0 1 1.8-1.8h2.8a1.8 1.8 0 0 1 1.8 1.8v1.8" />
    <path d="M2.8 12.6h18.4" />
  </Icon>
);

const IconMic = (p: IconProps) => (
  <Icon {...p}>
    <rect x="9.2" y="2.6" width="5.6" height="11" rx="2.8" />
    <path d="M5.6 11.4a6.4 6.4 0 0 0 12.8 0" />
    <path d="M12 17.8v3.6" />
  </Icon>
);

const IconBook = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 4.4h5.2A2.8 2.8 0 0 1 12 7.2v13a2.2 2.2 0 0 0-2.2-1.7H4z" />
    <path d="M20 4.4h-5.2A2.8 2.8 0 0 0 12 7.2v13a2.2 2.2 0 0 1 2.2-1.7H20z" />
  </Icon>
);

const IconTrophy = (p: IconProps) => (
  <Icon {...p}>
    <path d="M7.4 3.6h9.2v5.2a4.6 4.6 0 0 1-9.2 0z" />
    <path d="M7.4 5.2H4.6v1.4a3.2 3.2 0 0 0 2.8 3.2" />
    <path d="M16.6 5.2h2.8v1.4a3.2 3.2 0 0 1-2.8 3.2" />
    <path d="M12 13.4v3.4" />
    <path d="M8.4 20.4h7.2l-.8-3.6H9.2z" />
  </Icon>
);

export const IconCoins = (p: IconProps) => (
  <Icon {...p}>
    <ellipse cx="12" cy="6.6" rx="7.4" ry="3.2" />
    <path d="M4.6 6.6v4.8c0 1.8 3.3 3.2 7.4 3.2s7.4-1.4 7.4-3.2V6.6" />
    <path d="M4.6 11.4v5c0 1.8 3.3 3.2 7.4 3.2s7.4-1.4 7.4-3.2v-5" />
  </Icon>
);

/**
 * Imkoniyat turi -> ikonka (taxonomy.TYPES bilan bir xil kalitlar).
 * Ro'yxatda yo'q tur uchun zaxira — IconSparkle.
 */
export const TYPE_ICON: Record<string, (p: IconProps) => JSX.Element> = {
  talim: IconCap,
  almashinuv: IconExchange,
  tadqiqot: IconFlask,
  ish: IconBriefcase,
  tadbir: IconMic,
  trening: IconBook,
  tanlov: IconTrophy,
  loyiha: IconCoins,
};

export function TypeIcon({
  type,
  size = 20,
  className,
}: {
  type: string | null;
  size?: number;
  className?: string;
}) {
  const Cmp = (type && TYPE_ICON[type]) || IconSparkle;
  return <Cmp size={size} className={className} />;
}
